import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilePondModule } from 'ngx-filepond';
import acceptedImages from '../../../../../../common/constants/acceptedImages';
import PictureTypes from '../../../../../../common/enums/pictureTypes';
import { ImageType } from '../../../../../../core/data/models/ImageType';
import pictureTypes from '../../../../../../common/enums/pictureTypes';
import { FormInputDirective } from '../../../../../../common/directives/form-input.directive';

@Component({
    selector: 'app-cristal-form',
    imports: [FormsModule, ReactiveFormsModule, FilePondModule],
    templateUrl: './cristal-form.component.html',
    styleUrl: './cristal-form.component.css'
})
export class CristalFormComponent {
  @Input() cristalForm!: FormGroup;
  @ViewChildren(FormInputDirective)
  validatedInputs!: QueryList<FormInputDirective>;
  @Output() onImagesChange = new EventEmitter<
    { file: File; type: PictureTypes }[]
  >();

  pictureTypes = PictureTypes;

  newImages: (ImageType & { id: number })[] = [];
  picOptions = {
    multiple: false,
    labelIdle: 'Arrastra la imagen o click para elegir',
    acceptedFileTypes: acceptedImages,
    allowReorder: true,
  };

  handleAddImage($event: any, type: PictureTypes) {
    this.newImages.push({
      id: $event.file.id,
      file: $event.file.file,
      type,
    });
    this.onImagesChange.emit(
      this.newImages.map((image) => ({ file: image.file, type: image.type })),
    );
  }

  handleRemoveImage($event: any) {
    const index = this.newImages.findIndex(
      (image) => image.id === $event.file.id,
    );

    if (index > -1) {
      this.newImages.splice(index, 1);
    }

    this.onImagesChange.emit(
      this.newImages.map((image) => ({ file: image.file, type: image.type })),
    );
  }
}
